module.exports = __webpack_public_path__ + "media/images/lb/253-0766f845b12f1f5f11030bafb4e30cde.svg";